import { formatInTimeZone } from 'date-fns-tz';
import { getTimeZoneAbbreviation } from './timezone';
import type { CwyTransferRequest } from '../features/wallet/services/walletService';

/**
 * Compact timestamp for transaction lists: date, time, and timezone abbreviation.
 */
export function formatTransactionTimestamp(value?: string, timeZone?: string): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formatted = formatInTimeZone(date, tz, 'MMM d, yyyy · h:mm a');
  const abbr = getTimeZoneAbbreviation(date, tz);
  return abbr ? `${formatted} ${abbr}` : formatted;
}

/** Prefer on-chain confirmation, then review, then request time. */
export function getTransactionDisplayTimestamp(request: CwyTransferRequest): string | undefined {
  return request.tx_confirmed_at ?? request.reviewed_at ?? request.createdAt;
}
